__turbopack_context__.v({
  "content": "AboutPremiumContent-module-scss-module__uWF5eG__content",
  "linkContainer": "AboutPremiumContent-module-scss-module__uWF5eG__linkContainer",
  "sectionHeading": "AboutPremiumContent-module-scss-module__uWF5eG__sectionHeading",
});
